import React from 'react';

const ContentStatsBar = ({ stats }) => (
  <div className="sc-stats-bar animate-fade-in">
    {stats.map((stat, index) => (
      <React.Fragment key={stat.label}>
        {index > 0 && <div className="sc-stat-divider"></div>}
        <div className="sc-stat">
          <span className="sc-stat-value">{stat.value}</span>
          <span className="sc-stat-label">{stat.label}</span>
        </div>
      </React.Fragment>
    ))}
  </div>
);

export default ContentStatsBar;
